import { useLocation, useNavigate } from "react-router-dom";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper";
import { SwiperSlide } from "swiper/react";
import DetailPageLayout from "./../Layout/DetailPageLayout";
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/scrollbar/scrollbar.min.css";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import {
  BarcodeBox,
  ButtonIcon,
  Buttons,
  CancelBox,
  ContentContainer,
  DetailBox,
  Grid,
  SlideImage,
  Slider,
} from "./TicketDetail.styles";
import TicketDetailTab from "./TicketDetailTab";
import { TextM } from "../../common/text";
import TicketBarcode from "./TicketBarcode";
import TicketQRcode from "./TicketQRcode";
import {
  validateCancelRequestOpen,
  validateCodeOpen,
} from "./TicketDetail.helpers";

const BarcodeIconUrl = process.env.PUBLIC_URL + "/icons/barcode01.png";
const CancelIconUrl = process.env.PUBLIC_URL + "/icons/cancel.png";
const QRCodeIconUrl = process.env.PUBLIC_URL + "/icons/qrcode01.png";
SwiperCore.use([Pagination, Autoplay, Navigation]);

const TicketDetail = () => {
  const {
    state: { ticket },
  } = useLocation();

  const [isUsedTicket, setIsUsedTicket] = useState(false); // 사용한 티켓인지 아닌지
  const [isCodeOpen, setIsCodeOpen] = useState(false); // 바코드/QR코드 열렸는지

  const navigate = useNavigate();
  const goToTicketCancel = (pk) => {
    navigate("/my-tickets/" + pk + "/cancel", {
      state: { ticket },
      replace: true,
    });
  };

  useEffect(() => {
    if (ticket?.usedDate) {
      // 사용티켓 => 바코드 조회/취소신청 원천 차단(아예 안보이게)
      setIsUsedTicket(true);
    }
  }, []);

  return (
    <DetailPageLayout headerText={ticket.product.name}>
      <Helmet>
        <title>티켓상세</title>
      </Helmet>
      <ContentContainer>
        <Grid>
          <Slider
            spaceBetween={8}
            initialSlide={0}
            centeredSlides={true}
            pagination={{
              clickable: true,
            }}
            autoplay={{ delay: 3000 }}
          >
            {ticket.product.images.map((image, i) => (
              <SwiperSlide key={i}>
                <img src={image} />
              </SwiperSlide>
            ))}
          </Slider>

          <DetailBox>
            <TicketDetailTab ticket={ticket} isUsedTicket={isUsedTicket} />
            {!isUsedTicket && (
              <Buttons>
                <BarcodeBox
                  onClick={() => validateCodeOpen(ticket, setIsCodeOpen)}
                >
                  <ButtonIcon
                    src={ticket.isBarcode ? BarcodeIconUrl : QRCodeIconUrl}
                  />
                  <TextM color="#ffffff">
                    {ticket.isBarcode ? "바코드 확인" : "QR 확인"}
                  </TextM>
                </BarcodeBox>

                <CancelBox
                  onClick={() =>
                    validateCancelRequestOpen(ticket, goToTicketCancel)
                  }
                >
                  <ButtonIcon src={CancelIconUrl} />
                  <TextM color="gray">구매취소</TextM>
                </CancelBox>
              </Buttons>
            )}
          </DetailBox>
        </Grid>
      </ContentContainer>
      {isCodeOpen && ticket.isBarcode && (
        <TicketBarcode
          setIsCodeOpen={setIsCodeOpen}
          ticket={ticket}
        ></TicketBarcode>
      )}
      {isCodeOpen && !ticket.isBarcode && (
        <TicketQRcode
          setIsCodeOpen={setIsCodeOpen}
          ticket={ticket}
        ></TicketQRcode>
      )}
    </DetailPageLayout>
  );
};

export default TicketDetail;
